export type VideoType = "movie" | "tv" | "short";

export interface Video {
  id: string;
  title: string;
  type: VideoType;
  region: string;
  year: number;
  genres: string[];
  duration: string;
  director: string;
  cast: string[];
  rating: number;
  popularity: number;
  createdAt: string;
  summary: string;
  cover: string;
  banner?: string;
  tags: string[];
}

export const videos: Video[] = [
  {
    id: "v001",
    title: "暮色追光",
    type: "movie",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "悬疑"],
    duration: "128分钟",
    director: "陈默然",
    cast: ["林知远", "苏晚晴", "赵启明"],
    rating: 8.7,
    popularity: 9850,
    createdAt: "2024-11-02",
    summary:
      "一名失忆的档案管理员在整理旧卷宗时，发现一桩被刻意掩埋的旧案与自己身世纠缠不清。随着线索层层剥开，真相与谎言在暮色中交错，他必须在光与暗之间做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20figure%20silhouetted%20against%20dusk%20city%20skyline%2C%20moody%20amber%20and%20deep%20slate%20tones%2C%20mysterious%20suspense%20atmosphere%2C%20dramatic%20lighting%2C%20minimal%20elegant%20composition%2C%20film%20noir%20aesthetic&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20moody%20dusk%20metropolitan%20skyline%20with%20warm%20amber%20light%20streaks%20and%20deep%20slate%20shadows%2C%20suspense%20film%20atmosphere%2C%20dramatic%20clouds%2C%20rich%20contrast%2C%20editorial%20movie%20key%20art&width=1920&height=1080&seq=movie-banner-01&orientation=landscape",
    tags: ["悬疑", "反转", "高口碑"],
  },
  {
    id: "v002",
    title: "山海幻境",
    type: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["奇幻", "冒险"],
    duration: "142分钟",
    director: "顾长风",
    cast: ["周砚白", "叶清欢", "沈昭"],
    rating: 8.2,
    popularity: 8720,
    createdAt: "2023-08-19",
    summary:
      "少年为寻回被山海异兽夺走的族人魂魄，踏上穿越九重幻境的旅途。云雾翻涌之间，古老的图腾与失落的文明逐一苏醒，一场关于勇气与选择的冒险就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20movie%20poster%20of%20a%20young%20traveler%20before%20misty%20mythical%20mountains%2C%20ethereal%20teal%20and%20warm%20gold%20accents%2C%20ancient%20totem%20motifs%2C%20epic%20adventure%20mood%2C%20painterly%20illustration%2C%20cinematic%20composition&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20of%20floating%20mythical%20mountains%20shrouded%20in%20mist%2C%20ethereal%20teal%20light%20with%20warm%20golden%20accents%2C%20ancient%20ruins%2C%20sweeping%20cinematic%20composition%2C%20rich%20atmospheric%20depth&width=1920&height=1080&seq=movie-banner-02&orientation=landscape",
    tags: ["奇幻", "冒险", "视觉大片"],
  },
  {
    id: "v003",
    title: "逆流而上",
    type: "movie",
    region: "美国",
    year: 2022,
    genres: ["动作", "犯罪"],
    duration: "116分钟",
    director: "Marcus Vale",
    cast: ["Ethan Cole", "Nora Reed", "Leo Grant"],
    rating: 7.9,
    popularity: 7640,
    createdAt: "2022-06-11",
    summary:
      "一名退役的水上救援员被卷入跨国走私网络，为洗清挚友的冤屈，他独自逆流追击真相。湍急的河道与冰冷的阴谋交织，每一次抉择都可能是致命的。",
    cover:
      "https://readdy.ai/api/search-image?query=Action%20thriller%20poster%20of%20a%20determined%20man%20in%20a%20rushing%20river%20under%20stormy%20sky%2C%20cool%20steel%20blue%20and%20orange%20highlights%2C%20gritty%20cinematic%20texture%2C%20tense%20atmosphere%2C%20bold%20dramatic%20composition&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    tags: ["动作", "犯罪", "追逐"],
  },
  {
    id: "v004",
    title: "星河旅人",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    genres: ["科幻", "剧情"],
    duration: "134分钟",
    director: "韩星野",
    cast: ["顾南舟", "许微光", "郑屿"],
    rating: 8.9,
    popularity: 11230,
    createdAt: "2025-03-21",
    summary:
      "末世之后，最后一批人类搭乘方舟驶向深空。年轻的导航员在漫长航程中发现了一段被删除的星图，那是一段关于回家的秘密航线，也是一个足以改变人类命运的抉择。",
    cover:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20movie%20poster%20of%20a%20lone%20astronaut%20before%20a%20vast%20glowing%20galaxy%2C%20deep%20indigo%20and%20warm%20amber%20star%20glow%2C%20epic%20space%20opera%20feel%2C%20cinematic%20volumetric%20lighting%2C%20minimalist%20elegant%20layout&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20space%20nebula%20with%20glowing%20amber%20and%20indigo%20star%20clusters%2C%20a%20small%20spaceship%20silhouette%2C%20epic%20sci%20fi%20key%20art%2C%20cinematic%20volumetric%20lighting%2C%20rich%20contrast&width=1920&height=1080&seq=movie-banner-04&orientation=landscape",
    tags: ["科幻", "太空", "年度期待"],
  },
  {
    id: "v005",
    title: "无声告白",
    type: "movie",
    region: "日本",
    year: 2021,
    genres: ["剧情", "爱情"],
    duration: "108分钟",
    director: "佐藤原",
    cast: ["小林凛", "高桥悠"],
    rating: 8.4,
    popularity: 6980,
    createdAt: "2021-09-05",
    summary:
      "在一座临海小镇，两个都习惯了沉默的人因为一台旧收音机相遇。他们用写信代替对话，用四季代替誓言，慢慢学会了如何把心意说出口。",
    cover:
      "https://readdy.ai/api/search-image?query=Tender%20romantic%20movie%20poster%20of%20two%20figures%20by%20a%20seaside%20window%20at%20golden%20hour%2C%20soft%20muted%20beige%20and%20warm%20rose%20tones%2C%20gentle%20nostalgic%20mood%2C%20minimal%20air%20illustration%2C%20delicate%20composition&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    tags: ["爱情", "治愈", "日系"],
  },
  {
    id: "v006",
    title: "极夜迷城",
    type: "movie",
    region: "韩国",
    year: 2024,
    genres: ["悬疑", "惊悚"],
    duration: "121分钟",
    director: "박준호",
    cast: ["이서연", "김도현", "최민재"],
    rating: 8.1,
    popularity: 8210,
    createdAt: "2024-07-14",
    summary:
      "永夜笼罩的北方小城连续发生失踪案，一名失眠的刑警在极夜里追查线索，却发现整座城市都在守护同一个秘密。天再也不会亮了，而真相只在黑暗里生长。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20poster%20of%20a%20snowy%20city%20under%20endless%20polar%20night%2C%20cold%20slate%20blue%20and%20faint%20amber%20streetlights%2C%20eerie%20isolated%20atmosphere%2C%20moody%20cinematic%20texture&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    tags: ["悬疑", "惊悚", "韩剧"],
  },
  {
    id: "v007",
    title: "花开彼岸",
    type: "movie",
    region: "中国香港",
    year: 2023,
    genres: ["文艺", "爱情"],
    duration: "99分钟",
    director: "梁又宁",
    cast: ["陈昕", "何启铭"],
    rating: 7.6,
    popularity: 5240,
    createdAt: "2023-05-27",
    summary:
      "花店店主与旧信收藏者在即将拆迁的老街相遇，一封封无人认领的信把他们带回过去。花开在彼岸，人却只能在这边，隔着岁月相望。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20romance%20movie%20poster%20of%20a%20flower%20shop%20alley%20in%20soft%20rain%2C%20muted%20sage%20green%20and%20dusty%20rose%20tones%2C%20melancholic%20poetic%20mood%2C%20painterly%20texture%2C%20delicate%20composition&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    tags: ["文艺", "爱情", "港片"],
  },
  {
    id: "v008",
    title: "铁血边境",
    type: "movie",
    region: "中国大陆",
    year: 2022,
    genres: ["战争", "历史"],
    duration: "145分钟",
    director: "贺兰山",
    cast: ["吴铁", "孟长河", "陈岩"],
    rating: 8.3,
    popularity: 7430,
    createdAt: "2022-10-01",
    summary:
      "风雪边关，一支小队奉命坚守无名的高地。没有后援，没有退路，他们用血肉之躯写下了一段无人知晓的忠诚。历史会记住每一个不肯后退的人。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20war%20movie%20poster%20of%20soldiers%20holding%20a%20snowy%20frontier%20ridge%2C%20cold%20grey%20and%20warm%20ember%20firelight%2C%20solemn%20heroic%20atmosphere%2C%20gritty%20cinematic%20texture%2C%20dramatic%20composition&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    tags: ["战争", "历史", "主旋律"],
  },
  {
    id: "v009",
    title: "长安十二辰",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "悬疑"],
    duration: "全48集",
    director: "裴景舟",
    cast: ["萧亦寒", "温云舒", "陆明远"],
    rating: 8.8,
    popularity: 13420,
    createdAt: "2024-02-18",
    summary:
      "上元灯节前夕，长安城暗流涌动。一名办案如神的小吏与一名江湖女侠被迫联手，在十二个时辰内阻止一场足以颠覆朝局的阴谋。灯火背后，人心比夜色更深。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20of%20an%20ancient%20lantern%20lit%20city%20at%20night%2C%20warm%20lantern%20amber%20and%20deep%20ink%20blue%2C%20elegant%20traditional%20aesthetic%2C%20cinematic%20moody%20composition&width=600&height=900&seq=tv-cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20glowing%20with%20countless%20lanterns%20at%20night%2C%20warm%20amber%20glow%20and%20deep%20ink%20blue%20shadows%2C%20majestic%20cinematic%20panorama%2C%20rich%20atmospheric%20depth&width=1920&height=1080&seq=tv-banner-01&orientation=landscape",
    tags: ["古装", "悬疑", "口碑剧"],
  },
  {
    id: "v010",
    title: "都市浮生记",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["都市", "情感"],
    duration: "全36集",
    director: "林清越",
    cast: ["方宁", "顾念", "程屿"],
    rating: 7.8,
    popularity: 9620,
    createdAt: "2023-11-08",
    summary:
      "三个在大城市打拼的年轻人，在一栋旧公寓里相遇。合租、失业、恋爱、告别，生活的褶皱里藏着最真实的烟火气。有人离开，有人留下，有人重新开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20young%20people%20on%20a%20city%20rooftop%20at%20dusk%2C%20warm%20peach%20and%20soft%20slate%20tones%2C%20bittersweet%20lifestyle%20mood%2C%20clean%20editorial%20composition&width=600&height=900&seq=tv-cover-02&orientation=portrait",
    tags: ["都市", "情感", "生活"],
  },
  {
    id: "v011",
    title: "暗夜守望者",
    type: "tv",
    region: "美国",
    year: 2025,
    genres: ["科幻", "悬疑"],
    duration: "全24集",
    director: "Ava Sinclair",
    cast: ["Ryan Bell", "Maya Ford", "Owen Shaw"],
    rating: 8.6,
    popularity: 10870,
    createdAt: "2025-01-30",
    summary:
      "一群拥有特殊感知能力的人，默默守护着城市与人性的边界。当旧日对手重新苏醒，他们必须在被误解与孤立的处境下，再一次选择站出来。",
    cover:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20series%20poster%20of%20hooded%20vigilantes%20on%20a%20dark%20neon%20city%20street%2C%20deep%20indigo%20and%20electric%20amber%20accents%2C%20tense%20superhero%20mood%2C%20dramatic%20cinematic%20lighting&width=600&height=900&seq=tv-cover-03&orientation=portrait",
    tags: ["科幻", "悬疑", "美剧"],
  },
  {
    id: "v012",
    title: "江南烟雨录",
    type: "tv",
    region: "中国大陆",
    year: 2022,
    genres: ["古装", "爱情"],
    duration: "全40集",
    director: "沈砚书",
    cast: ["谢云归", "柳如烟", "江辰"],
    rating: 7.9,
    popularity: 8890,
    createdAt: "2022-04-16",
    summary:
      "江南水乡，一场烟雨将两位身份悬殊的男女引入了彼此的世界。家族恩怨、朝堂暗涌与他们无法言说的心意交织，谁能等到雨停的那一天。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20romance%20drama%20poster%20of%20a%20misty%20jiangnan%20water%20town%20with%20an%20umbrella%20couple%2C%20soft%20jade%20green%20and%20warm%20ink%20tones%2C%20romantic%20poetic%20mood%2C%20elegant%20painterly%20composition&width=600&height=900&seq=tv-cover-04&orientation=portrait",
    tags: ["古装", "爱情", "国风"],
  },
  {
    id: "v013",
    title: "破晓行动",
    type: "tv",
    region: "韩国",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    duration: "全16集",
    director: "정민석",
    cast: ["박지훈", "한소율", "윤재현"],
    rating: 8.5,
    popularity: 10240,
    createdAt: "2024-09-12",
    summary:
      "一桩悬置十年的旧案在新证据出现后重新启动，老刑警与年轻检察官组成特别小组。他们要在天亮之前，把藏在黑暗里的那只手拽出来。",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20series%20poster%20of%20detectives%20in%20a%20dark%20office%20with%20case%20files%2C%20cold%20slate%20blue%20and%20orange%20lamp%20glow%2C%20tense%20investigative%20mood%2C%20gritty%20cinematic%20texture&width=600&height=900&seq=tv-cover-05&orientation=portrait",
    tags: ["犯罪", "悬疑", "韩剧"],
  },
  {
    id: "v014",
    title: "医者仁心",
    type: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["医疗", "剧情"],
    duration: "全32集",
    director: "唐知白",
    cast: ["邵怀安", "方榆", "顾清和"],
    rating: 8.0,
    popularity: 7010,
    createdAt: "2023-06-25",
    summary:
      "急诊科的日与夜，是与时间赛跑的战场。一群平凡的医护人员在一次次生死抉择中，守护着病人也守护着彼此心中的那盏灯。",
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%20of%20doctors%20in%20a%20bright%20hospital%20corridor%2C%20clean%20soft%20teal%20and%20warm%20white%20tones%2C%20hopeful%20serious%20mood%2C%20minimal%20editorial%20composition&width=600&height=900&seq=tv-cover-06&orientation=portrait",
    tags: ["医疗", "剧情", "职场"],
  },
  {
    id: "v015",
    title: "城市漫游Vlog",
    type: "short",
    region: "中国大陆",
    year: 2025,
    genres: ["生活", "纪录"],
    duration: "08:24",
    director: "阿屿",
    cast: ["阿屿"],
    rating: 8.2,
    popularity: 5430,
    createdAt: "2025-05-02",
    summary:
      "一个人、一台相机，用脚步丈量城市的每个角落。清晨的早点摊、午后的旧书店、黄昏的天台，慢下来的城市原来这么好看。",
    cover:
      "https://readdy.ai/api/search-image?query=Lifestyle%20vlog%20cover%20of%20a%20person%20walking%20a%20sunny%20city%20street%20with%20a%20camera%2C%20warm%20daylight%20and%20soft%20pastel%20tones%2C%20relaxed%20travel%20mood%2C%20clean%20modern%20composition&width=600&height=900&seq=short-cover-01&orientation=portrait",
    tags: ["生活", "纪录", "慢生活"],
  },
  {
    id: "v016",
    title: "一分钟美食日记",
    type: "short",
    region: "中国大陆",
    year: 2025,
    genres: ["美食", "生活"],
    duration: "01:12",
    director: "小满",
    cast: ["小满"],
    rating: 8.6,
    popularity: 8120,
    createdAt: "2025-06-18",
    summary:
      "用短短一分钟，记录一道家常菜从备料到出锅的全过程。没有复杂的技巧，只有热气腾腾的烟火气，和让人想立刻下厨的冲动。",
    cover:
      "https://readdy.ai/api/search-image?query=Food%20short%20video%20cover%20of%20steaming%20homemade%20dishes%20on%20a%20wooden%20table%2C%20warm%20appetizing%20orange%20and%20cream%20tones%2C%20cozy%20kitchen%20mood%2C%20top%20down%20food%20photography&width=600&height=900&seq=short-cover-02&orientation=portrait",
    tags: ["美食", "生活", "治愈"],
  },
  {
    id: "v017",
    title: "街舞快闪实录",
    type: "short",
    region: "中国大陆",
    year: 2024,
    genres: ["音乐", "舞蹈"],
    duration: "03:45",
    director: "节奏社",
    cast: ["节奏社"],
    rating: 8.3,
    popularity: 6540,
    createdAt: "2024-08-30",
    summary:
      "音乐突然响起，人群中央的舞者瞬间点燃整条街。多机位记录下一场没有彩排的街头快闪，看热血与节奏如何在人潮里炸开。",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20dance%20flash%20mob%20cover%20of%20dancers%20mid%20move%20in%20a%20crowded%20plaza%2C%20vivid%20orange%20and%20deep%20indigo%20accents%2C%20energetic%20urban%20mood%2C%20dynamic%20motion%20blur%20composition&width=600&height=900&seq=short-cover-03&orientation=portrait",
    tags: ["音乐", "舞蹈", "街头"],
  },
  {
    id: "v018",
    title: "萌宠日常大赏",
    type: "short",
    region: "中国大陆",
    year: 2025,
    genres: ["宠物", "搞笑"],
    duration: "02:08",
    director: "橘猫编辑部",
    cast: ["橘猫编辑部"],
    rating: 8.9,
    popularity: 9870,
    createdAt: "2025-07-09",
    summary:
      "猫猫狗狗的沙雕名场面合集。拆家、装无辜、抢零食、睡到翻肚皮，治愈你一天的疲惫，看完只想立刻拥有一只。",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20pet%20video%20cover%20of%20a%20fluffy%20orange%20cat%20and%20a%20golden%20retriever%20on%20a%20sunny%20rug%2C%20soft%20warm%20cream%20tones%2C%20adorable%20cheerful%20mood%2C%20bright%20clean%20composition&width=600&height=900&seq=short-cover-04&orientation=portrait",
    tags: ["宠物", "搞笑", "治愈"],
  },
  {
    id: "v019",
    title: "极限运动瞬间",
    type: "short",
    region: "美国",
    year: 2024,
    genres: ["运动", "纪录"],
    duration: "05:30",
    director: "Peak Crew",
    cast: ["Peak Crew"],
    rating: 8.1,
    popularity: 5780,
    createdAt: "2024-10-22",
    summary:
      "滑雪、攀岩、越野跑、自由潜，用镜头记录人类挑战自然极限的每一个瞬间。肾上腺素与壮阔风景一起冲上顶峰。",
    cover:
      "https://readdy.ai/api/search-image?query=Extreme%20sports%20video%20cover%20of%20a%20skier%20mid%20air%20against%20snowy%20mountains%2C%20cold%20blue%20and%20vivid%20orange%20accents%2C%20adrenaline%20dramatic%20mood%2C%20cinematic%20wide%20composition&width=600&height=900&seq=short-cover-05&orientation=portrait",
    tags: ["运动", "纪录", "热血"],
  },
  {
    id: "v020",
    title: "手作时光",
    type: "short",
    region: "中国大陆",
    year: 2025,
    genres: ["手工", "生活"],
    duration: "06:16",
    director: "木野",
    cast: ["木野"],
    rating: 8.4,
    popularity: 4620,
    createdAt: "2025-04-11",
    summary:
      "从一块木头到一件温润的器物，跟着手作人慢慢打磨时光。木屑纷飞之间，浮躁的心也一点点安静下来。",
    cover:
      "https://readdy.ai/api/search-image?query=Craft%20woodworking%20video%20cover%20of%20hands%20carving%20a%20wooden%20object%20in%20a%20warm%20workshop%2C%20earthy%20amber%20and%20soft%20brown%20tones%2C%20calm%20artisanal%20mood%2C%20cozy%20natural%20lighting&width=600&height=900&seq=short-cover-06&orientation=portrait",
    tags: ["手工", "生活", "解压"],
  },
];

export interface CategoryMeta {
  type: VideoType;
  label: string;
  intro: string;
  icon: string;
}

export const categoryMeta: Record<VideoType, CategoryMeta> = {
  movie: {
    type: "movie",
    label: "电影",
    intro: "汇聚剧情、悬疑、科幻、动作等多元题材的高质量电影作品，从年度话题大作到口碑佳作，带你快速找到下一部想看的片子。",
    icon: "ri-film-line",
  },
  tv: {
    type: "tv",
    label: "电视剧",
    intro: "覆盖国产剧、美剧、韩剧等多地区热播剧集，古装、都市、悬疑、医疗各有精彩，追剧从此不再剧荒。",
    icon: "ri-live-line",
  },
  short: {
    type: "short",
    label: "短视频",
    intro: "美食、生活、宠物、运动、舞蹈等短小精悍的内容合集，随时随地刷上一段，用碎片时间收获满满的快乐。",
    icon: "ri-play-circle-line",
  },
};

export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  tags: string[];
}

export const topics: Topic[] = [
  {
    id: "t1",
    title: "悬疑烧脑特辑",
    subtitle: "反转不断，一起揭开层层迷雾",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20mystery%20collection%20cover%20with%20shadowy%20silhouette%20and%20glowing%20magnifier%2C%20deep%20slate%20and%20amber%20tones%2C%20tense%20noir%20atmosphere%2C%20cinematic%20composition&width=800&height=600&seq=topic-cover-01&orientation=landscape",
    tags: ["悬疑", "犯罪", "惊悚"],
  },
  {
    id: "t2",
    title: "治愈系生活合集",
    subtitle: "慢下来，感受生活的小确幸",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20healing%20lifestyle%20collection%20cover%20with%20warm%20sunlit%20window%20and%20plants%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20calm%20peaceful%20mood%2C%20minimal%20composition&width=800&height=600&seq=topic-cover-02&orientation=landscape",
    tags: ["生活", "治愈", "美食"],
  },
  {
    id: "t3",
    title: "高燃动作精选",
    subtitle: "肾上腺素拉满的视听盛宴",
    cover:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20collection%20cover%20with%20explosive%20orange%20sparks%20and%20dark%20silhouette%2C%20dramatic%20contrast%2C%20energetic%20cinematic%20mood&width=800&height=600&seq=topic-cover-03&orientation=landscape",
    tags: ["动作", "战争", "冒险"],
  },
  {
    id: "t4",
    title: "国风古装精选",
    subtitle: "衣袂翩跹，梦回千年",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20costume%20drama%20collection%20cover%20with%20lanterns%20and%20plum%20blossoms%2C%20jade%20green%20and%20warm%20gold%20tones%2C%20poetic%20traditional%20aesthetic&width=800&height=600&seq=topic-cover-04&orientation=landscape",
    tags: ["古装", "国风", "爱情"],
  },
];

export const regionOptions = ["全部", "中国大陆", "美国", "韩国", "日本", "中国香港"];
export const yearOptions = ["全部", "2025", "2024", "2023", "2022", "2021"];
export const genreOptions: Record<VideoType, string[]> = {
  movie: ["全部", "剧情", "悬疑", "科幻", "动作", "犯罪", "奇幻", "冒险", "爱情", "战争", "历史", "文艺"],
  tv: ["全部", "古装", "悬疑", "都市", "情感", "科幻", "犯罪", "爱情", "医疗", "剧情"],
  short: ["全部", "生活", "纪录", "美食", "音乐", "舞蹈", "宠物", "搞笑", "运动", "手工"],
};

export const getVideoById = (id: string): Video | undefined => videos.find((v) => v.id === id);

export const getFeatured = (): Video[] => ["v004", "v009", "v001", "v002"].map((id) => getVideoById(id)!).filter(Boolean);

export const getByType = (type: VideoType): Video[] => videos.filter((v) => v.type === type);

export const getRelated = (video: Video, limit = 4): Video[] => {
  const scored = videos
    .filter((v) => v.id !== video.id)
    .map((v) => {
      let score = 0;
      if (v.type === video.type) score += 3;
      score += v.tags.filter((t) => video.tags.includes(t)).length * 2;
      score += v.genres.filter((g) => video.genres.includes(g)).length * 2;
      return { v, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.v);
};

export const formatType = (type: VideoType): string => categoryMeta[type].label;